import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'
import { useFormik } from 'formik'

import AddPagesForm from '../../../../AddPagesForm'

import { usePurifiedFormik } from '../../../../../../../hooks/formHooks/usePurifiedFormik'

import { formatOptionsList } from '../../../../../../../features/formatters'

import { addAccessibleSocialPages } from '../../../../../../../modules/actions/socialAccounts'
import {
  accessibleSocialPagesSelector,
  facebookPagesSelector
} from '../../../../../../../modules/selectors/socialAccounts'
import { selectedPartnershipIdSelector } from '../../../../../../../modules/selectors/partnerships'

import { initialValues, PAGE_ID } from '../../../../AddPagesForm/fields'
import { FACEBOOK_PROVIDER_PLATFORM } from '../../../../../../../constants/selectLists/platformList'

const AddFacebookPageForm = () => {
  const dispatch = useDispatch()

  const facebookPages = useSelector(facebookPagesSelector)
  const selectedPartnershipId = useSelector(selectedPartnershipIdSelector)
  const accessibleSocialPages = useSelector(accessibleSocialPagesSelector)

  // don't show already added pages. Filter out pages which exist in accessibleSocialPages list
  const availablePages = facebookPages.filter(
    ({ id }) => !accessibleSocialPages.find(({ external_id }) => external_id === id)
  )
  const formattedFacebookPages = formatOptionsList({
    list: availablePages,
    valueName: 'id',
    labelName: 'name'
  })

  const onSubmit = useCallback(
    values => {
      const newFacebookPage = facebookPages.find(({ id }) => values[PAGE_ID] === id)

      dispatch(
        addAccessibleSocialPages({
          ...newFacebookPage,
          external_id: newFacebookPage.id,
          partnership: selectedPartnershipId,
          platform: FACEBOOK_PROVIDER_PLATFORM
        })
      )
    },
    [dispatch, facebookPages, selectedPartnershipId]
  )

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      [PAGE_ID]: Yup.string().required('Please select Facebook page')
    }),
    onSubmit
  })
  const purifiedFormik = usePurifiedFormik(formik)

  return (
    <AddPagesForm formik={purifiedFormik} pagesOptions={formattedFacebookPages} provider={FACEBOOK_PROVIDER_PLATFORM} />
  )
}

export default AddFacebookPageForm
